// 地域の目次 (Stockists ページ左カラム) のカレント表示。
// スクロール位置から「いま見ている地域」を決めて、対応する目次項目に
// aria-current="true" を付ける (見た目は Tailwind の aria-[current=true]: 側)。
//
// 判定はビューポート上部 35% に引いた線を使い、その線より上に頭が出ている
// グループのうち最後のものを現在地とする。IntersectionObserver と違い
// グループの高さ (1 件だけの地域もある) に結果が左右されない。
//
// 目次リンクのスムーススクロールは scripts/lenis.ts の a[href^="#"] 委譲が
// そのまま効く (scroll-margin-top も尊重される)

const LINE = 0.35;

export function initRegionNav() {
  const links = [
    ...document.querySelectorAll<HTMLAnchorElement>('[data-region-link]'),
  ];
  const sections = [
    ...document.querySelectorAll<HTMLElement>('[data-region-section]'),
  ];
  if (links.length === 0 || sections.length === 0) return;

  let raf = 0;

  const update = () => {
    raf = 0;

    const line = window.innerHeight * LINE;
    // 先頭のグループより上 (ページ最上部) では先頭を現在地にしておく
    let current = sections[0].dataset.regionSection;

    for (const section of sections) {
      if (section.getBoundingClientRect().top <= line) {
        current = section.dataset.regionSection;
      }
    }

    for (const link of links) {
      link.setAttribute(
        'aria-current',
        link.dataset.regionLink === current ? 'true' : 'false',
      );
    }
  };

  const request = () => {
    if (!raf) raf = requestAnimationFrame(update);
  };

  // Lenis はネイティブスクロールを lerp で動かすので scroll がそのまま届く
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);
  // フォント読み込みでカードの高さが変わるため、確定後に取り直す
  window.addEventListener('load', request);
  update();
}
